import { render, staticRenderFns } from "./ContentReplyEntry.vue?vue&type=template&id=1531c60a&"
import script from "./ContentReplyEntry.vue?vue&type=script&lang=js&"
export * from "./ContentReplyEntry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports